import React, { useContext, useEffect, useState } from "react";
import { RouteComponentProps } from "react-router-dom";
import { Card, Image, Table, Button, Grid } from "semantic-ui-react";
import LoadingComponent from "../../../app/layout/LoadingComponent";
import TechnicianTransmissionStore from "../../../app/stores/techniciantransmissionStore";
import { Link } from "react-router-dom";
import { observer } from "mobx-react-lite";
import TransmissionPhotoDropzone from "./TransmissionPhotoDropzone";

interface DetailParams {
  id: string;
}

const TechnicianTransmissionPhoto: React.FC<RouteComponentProps<DetailParams>> = ({
  match,
  history,
}) => {
  const techniciantransmissionStore = useContext(TechnicianTransmissionStore);
  const {
    submitting,
    loadTechnicianTransmission,
    techniciantransmission,
  } = techniciantransmissionStore;

  useEffect(() => {
    loadTechnicianTransmission(match.params.id);
  }, []);

  // if (loadingInitial || !asset)
  //   return <LoadingComponent content="Loading Asset ..." />;

  const [files, setFiles] = useState<any[]>([]);
  
  return (
    <Card fluid>
      <Card.Content>
        <Table definition fixed unstackable>
          <Table.Body>
            <Table.Row>
              <Table.HeaderCell width={8}>
              3.5 Equipment Validation / Installation <br></br>
                Minimum 1 photo of each on
              </Table.HeaderCell>
              <Table.HeaderCell>
              1. Full rack photo, clearly showing equipment installed<br></br>
              2. If unable to take full photo take a number of photos of each section of rack from top to bottom
              </Table.HeaderCell>
            </Table.Row>
            <Table.Row>
              <Table.Cell>1. Photo taken of each rack showing existing sub rack layout.
              <div>
          <Button
            color="grey"
            content={<TransmissionPhotoDropzone id={match.params.id} siteId={techniciantransmission!.projectSite.siteId} category="Equipment" />}
          />
          
        </div>
              </Table.Cell>
              <Table.Cell>
              
              </Table.Cell>
            </Table.Row>
            <Table.Row>
              <Table.Cell>2. Rack with existing sub rack removed</Table.Cell>
              <Table.Cell> photo </Table.Cell>
            </Table.Row>
            <Table.Row>
              <Table.Cell>3. Rack with new sub rack layout.</Table.Cell>
              <Table.Cell> photo </Table.Cell>
            </Table.Row>
          </Table.Body>
        </Table>
      </Card.Content>
      <Card.Content extra>
          <Button
            onClick={() => history.push("/employeeportal/techniciantransmission")}
            basic
            color="grey"
            content="Cancel"
          />
      </Card.Content>
    </Card>
  );
};

export default observer(TechnicianTransmissionPhoto);
